import api from './api';

export const getConversations = () => api.get('/v1/ai-chat/conversations');
export const getConversation = (id) => api.get(`/v1/ai-chat/conversations/${id}`);
export const deleteConversation = (id) => api.delete(`/v1/ai-chat/conversations/${id}`);
export const getUsage = () => api.get('/v1/ai-chat/usage');
// Note: chat uses native fetch for SSE streaming, not this service
